<template>
  <div style="height: 100%">
    <!--<editor-fold desc="cabecalho">-->
    <v-row class="pt-0 mt-0">
      <v-col class="pb-0 pt-0">
        <v-card
            class="mt-0 pb-0"
            outlined
            elevation="2"
        >
          <v-card-title class="pb-0">Slide</v-card-title>
          <v-card-text class="mb-0 pb-0">
            <form>
              <!--                        <form v-on:submit.prevent="getFromApi()">-->
              <v-row>
                <v-col cols="3">
                  <v-text-field
                      v-model="cpNome"
                      class="mb-0 mb-0"
                      autocomplete="off"
                      label="Nome"
                      placeholder="Nome do novo slide"
                      required
                  ></v-text-field>
                </v-col>
                <v-col>
                  <SelecionaPlayers v-model=selectedPlayers :timeline-id="timelineId"></SelecionaPlayers>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <v-text-field
                      v-model="cpTempoExibicao"
                      type="number"
                      min="5"
                      class="pb-0 mb-0"
                      label="Tempo de exibição em segundos"
                      placeholder="tempo em segundos"
                      dense
                  ></v-text-field>
                </v-col>

                <!--<editor-fold desc="timeline">-->
                <v-col>
                  <v-card
                      class="d-inline-flex py-1 grey darken-3 pa-0 ma-0 py-2 pl-2"
                      style="overflow-x: scroll; overflow-y: hidden; height: 6rem;"
                      width="100%"
                  >


<!--                    <SelecionaLayout></SelecionaLayout>-->

                    <v-card
                        v-for="(item, k, i) in $store.state.timelineStore.itens"
                        :key="k"
                        class="mr-1"
                        :class="($store.state.timelineStore.itemEmEdicaoIndex == k ? 'blue lighten-4' : '')"
                        outlined
                        style="height: 5rem; width: 5rem;"
                        @click="edit(k)"
                    >
                      <v-row class="mt-2 mr-2 mb-3">
                        <v-spacer></v-spacer>
                        <v-icon
                            @click="deleteQuadro(k)"
                            color="error"
                        >
                          mdi-delete
                        </v-icon>
                      </v-row>
                      <v-row class="ml-3" align="center">
                        <h1 class="">{{ showItemNumber(k, i) }}</h1>
                      </v-row>


                      <!--                      <Layout1 v-show="item.layoutTipoId == 1"></Layout1>-->
                      <!--                      <Layout2 v-show="item.layoutTipoId == 2"></Layout2>-->
                      <!--                      <Layout3 v-show="item.layoutTipoId == 3"></Layout3>-->
                    </v-card>

<!--                    <v-icon title="Adicionar quadro"-->
<!--                            color="blue"-->

<!--                            @click="addQuadro()"-->
<!--                    >-->
<!--                      mdi-plus-->
<!--                    </v-icon>-->

                    <v-btn

                        depressed
                        outlined
                        color="primary"
                        style="height: 5rem; width: 5rem;"
                        @click="addQuadro()"
                    >
                      <v-icon title="Adicionar quadro"
                              color="primary"
                      >
                        mdi-plus
                      </v-icon>
                    </v-btn>

                  </v-card>
                </v-col>
                <!--</editor-fold> timeline-->

              </v-row>
            </form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!--</editor-fold> cabecalho-->

    <!--<editor-fold desc="linha da area de edicao">-->
    <v-row>
      <v-col
          cols="3"
          style="background-color: white;"
          class="pr-0"
      >
        <v-card
            elevation="2"
            outlined
        >
          <Ferramentas></Ferramentas>
        </v-card>
      </v-col>

      <!--<editor-fold desc="col da edicao do quadro e do timeline">-->
      <v-col
          class="pl-1"
          cols="9"
      >
        <!--Samsung RU7100 eh 16:9 = 1,7777777777777778-->
        <div
            ref="container"
            :style="aspectRatioTelaEdicao['16:9'][1]"
            style="border: 1px red dashed; font-size: 100%; position: -webkit-sticky; position: sticky; top: 74px;"
        >
          <div
              v-if="$store.state.timelineStore.itens.length == 0"
          >
            <p class="text-h5" align="center">
              Área de edição
            </p>
            <p class="text-h6" align="center">
              Adicione um quadro clicando no ícone
              <v-icon>mdi-shape-square-plus</v-icon>
              a cima.
            </p>
          </div>

          <div
              v-else
              style="width: 100%; height: 100%; overflow: hidden;"
          >
            <div
                v-for="(item, k) in $store.state.timelineStore.itens"
                :key="item.layoutDivisoes[1].quadroIndex"
                style="width: 100%; height: 100%; overflow: hidden;"
                v-if="$store.state.timelineStore.itemEmEdicaoIndex == k"
            >
              <Layout1
                  exibindo-em="areaEdicao"
                  :quadro-atual-loop="item"
              ></Layout1>
<!--              <Layout2-->
<!--                  v-if="item.layoutTipoId == 2"-->
<!--                  exibindo-em="areaEdicao"-->
<!--                  :quadro-atual-loop="item"-->
<!--              ></Layout2>-->
<!--              <Layout3-->
<!--                  v-if="item.layoutTipoId == 3"-->
<!--                  exibindo-em="areaEdicao"-->
<!--                  :quadro-atual-loop="item"-->
<!--              ></Layout3>-->
            </div>
          </div>
        </div>
<!--        <v-row-->
<!--            no-gutters-->
<!--            style="height: 600px;"-->
<!--        >-->
<!--          <v-col-->
<!--              v-if="$store.state.timelineStore.itens.length == 0"-->
<!--              cols="12"-->
<!--          >-->
<!--            <v-card-->
<!--                style="border: 2px grey dashed"-->
<!--                class="fill-height"-->
<!--            >-->
<!--              <v-card-text>-->
<!--                <p class="text-h5" align="center">-->
<!--                  Área de edição-->
<!--                </p>-->
<!--                <p class="text-h6" align="center">-->
<!--                  Adicione um quadro clicando no ícone-->
<!--                  <v-icon>mdi-shape-square-plus</v-icon>-->
<!--                  a cima.-->
<!--                </p>-->
<!--              </v-card-text>-->
<!--            </v-card>-->
<!--          </v-col>-->
<!--        </v-row>-->
        <!--</editor-fold> row area de edicao-->
      </v-col>
      <!--</editor-fold> col da edicao do quadro e do timeline-->

    </v-row>
    <!--</editor-fold> linha da area de edicao-->

    <!--<editor-fold desc="buttons">-->
    <v-row>
      <v-col>
        <v-btn
            class="ma-2"
            color="secondary"
            to="/timeline"
            :disabled="btnSalvarLoading"
        >
          Voltar
        </v-btn>
        <v-btn
            @click="save"
            class="ma-2 "
            color="primary"
            :disabled="btnSalvarLoading"
            :loading="btnSalvarLoading"
        >
          Salvar
        </v-btn>
        <v-btn
            v-if="timelineId != 0"
            @click="save(true)"
            class="ma-2 "
            color="primary"
            :disabled="btnSalvarLoading"
            :loading="btnSalvarLoading"
        >
          Salvar e continuar na página
        </v-btn>
      </v-col>
    </v-row>
    <!--</editor-fold> buttons-->

    <Dialog
        :alert-dialog="alertDialog"
        :alert-dialog-text="alertDialogText"
    ></Dialog>

  </div>


</template>

<script>
import Layout1 from "./layouts/layout1";
import Layout2 from "./layouts/layout2";
import Layout3 from "./layouts/layout3";
import Dialog from "../../components/Dialog";
import SelecionaLayout from "./components/SelecionaLayout";
import Ferramentas from "./components/Ferramentas";
import {timelineMixin} from "./timelineMixin";
import SelecionaPlayers from "@/views/timeline/components/SelecionaPlayers";

export default {
  components: {SelecionaPlayers, Ferramentas, SelecionaLayout, Dialog, Layout3, Layout2, Layout1},
  mixins: [timelineMixin],
  data: () => ({
    timelineId: null,

    aspectRatioTelaEdicao: {
      '16:9': [
        {width: '960px', height: '540px'},
        {width: '1024px', height: '576px'}
      ]
    },

    alertDialog: false,
    alertDialogText: "",
    LayoutDialog: false,

    // btn loading
    btnSalvarLoading: null,

    selectedPlayers: []
  }),

  created() {
    this.$store.commit('resetTimelineState');
    this.$store.commit('setModoExibicaoSlides', 'edicao');
    this.timelineId = this.$route.params.timelineId;
    this.getFromApi();
  },

  mounted(){
    this.$store.commit('setTimelineMainContainerSize', {
      w: this.$refs.container.offsetWidth,
      h: this.$refs.container.offsetHeight,
    });
  },

  computed: {
    cpNome: {
      get() {
        return this.$store.state.timelineStore.nome;
      },
      set(value) {
        this.$store.commit('setTimelineNome', value);
      }
    },

    cpTempoExibicao: {
      get() {
        return this.$store.state.timelineStore.tempoExibicao;
      },
      set(value) {
        this.$store.commit('setTimelineTempoExibicao', value);
      }
    },

    cpItemEmEdicao() {
      return this.$store.getters.getItemEmEdicao;
    },
  },

  methods: {
    //copiado do carregaTipoLayoutSelecionado do selecionaLayout...
    addQuadro() {
      let timelineItem = {
        tempoExibicao: 8,
        layoutTipoId: 1,//fixo layout tipo 1 sempre, ateh au fazer uma limpeza
      };

      //add o layout tipo 1
      this.$store.dispatch('addTimelineItem', timelineItem);

      // add componente do tipo cartaz (agora td eh cartaz...)
      this.$store.commit('setTimelineDadosComponente', {
        componenteTipo: 'cartaz',
        componenteDados: {},
        configs: {}
      });

      this.dialog = false;
    },

    showItemNumber(k, i){
      if(i >= 0){
        return i + 1;
      }

      //para os slides criados antes de transformar a lista de itens(slides) de arr pra obj
      // nao existira o "i"" e o "k" vai vir como indice do array
      return k + 1;
    },

    getSelectedPlayers(selectedPlayers) {
      this.selectedPlayers = [];

      selectedPlayers = JSON.parse(JSON.stringify(selectedPlayers));
      if (selectedPlayers.length > 0) {
        this.selectedPlayers = selectedPlayers;
      }
    },

    edit(itemEmEdicaoUID) {
      this.$store.commit('setTimelineItemEmEdicaoIndexEmEdicao', itemEmEdicaoUID)
      this.setDivisaoNumeroEmEdicao(1);
    },

    deleteQuadro(key){
      if (confirm('Deseja remover o item do slide?')) {
        delete this.$store.state.timelineStore.itens[key];
        // this.$store.state.timelineStore.itens.splice(index, 1);

        // let lastItemIndex = this.$store.state.timelineStore.itens.length -1
        // let lastItem = this.$store.state.timelineStore.itens[lastItemIndex];
        // let itemEmEdicaoIndex = lastItem.layoutDivisoes[1].quadroIndex;

        // fruitObject[ Object.keys(fruitObject)[ Object.keys(fruitObject).length - 1 ] ];
        let lastItemKey = Object.keys(this.$store.state.timelineStore.itens)[Object.keys(this.$store.state.timelineStore.itens).length - 1];
        this.edit(lastItemKey);
      }
    },

    getFromApi() {
      if (this.timelineId == 0) {
        return false;
      }

      axios.get('/timelines/' + this.timelineId).then((response) => {
        let json = response.data.json;
        json = JSON.parse(json);
        this.$store.commit('setTimelineState', json);
        this.$store.commit('setTimelineId', this.timelineId);

        let firstItemKey = Object.keys(this.$store.state.timelineStore.itens)[0];
        this.edit(firstItemKey);

        this.selectedPlayers = response.data.players;

        // let json = JSON.parse(item.json);
        // json.id = item.id;
        // this.$store.commit('setTimelineState', json);
        // this.$store.commit('setTimelineId', this.$route.params.timelineId);
      }, (error) => {
        console.log(error);
      }).catch(error => {
        console.log(error)
        // this.errored = true
      }).finally(() => this.loading = false);
    },

    save(continuarNaPagina) {
      continuarNaPagina = continuarNaPagina ?? null;

      // this.loading = true;
      this.btnSalvarLoading = true;

      if (!this.$store.state.timelineStore.nome.length) {
        alert("O nome é obrigatório");

        this.loading = false;
        this.btnSalvarLoading = null;

        return false;
      }

      //faz o submit
      let axiosss;

      // console.log(this.timelineId);
      // console.log("--- (this.timelineId) fim    ------------");
      // console.log("");

      if (!parseInt(this.timelineId)) {
        axiosss = axios.post(this.$store.getters.getUsrEndpoint + '/timelines', {
          nome: this.$store.state.timelineStore.nome,
          json: JSON.stringify(this.$store.state.timelineStore),
          selectedPlayers: this.selectedPlayers
        });
      } else {
        axiosss = axios.put('/timelines/' + this.$store.state.timelineStore.id, {
          nome: this.$store.state.timelineStore.nome,
          json: JSON.stringify(this.$store.state.timelineStore),
          selectedPlayers: this.selectedPlayers
        });
      }

      axiosss.then((response) => {
        this.$store.commit('resetTimelineState');

        if (continuarNaPagina === true) {
          this.$router.go();
        } else {
          this.$router.push({path: '/timeline'});
        }
      }, (error) => {
        this.alertDialog = true;
        this.alertDialogText = "Houve um problema ao salvar o registro";
      }).catch(error => {
        console.log(error)
        // this.errored = true
      }).finally(() => {
        this.loading = false;
        this.btnSalvarLoading = null;
      });
    },
  },
}
</script>

<style scoped>
.timeline-item {
  width: 6rem;
  height: 4.6rem;
}
</style>
